function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M1 1v14h14V1H1zm.588.672H4.03v2.443H1.588V1.672zm3.39.017h2.444v2.444H4.979V1.689zm6.961.036h2.444V4.17h-2.444V1.725zM8.857 4.807h2.444v2.445H8.857V4.807zm-3.662.109H7.64v2.443H5.195V4.916zm6.817 3.117h2.443v2.446h-2.443V8.033zm-3.371.182h2.443v2.445H8.641V8.215zm-6.926.037h2.443v2.443H1.715V8.252zm3.445 3.117h2.444v2.445H5.16V11.37zm6.742.074h2.446v2.444h-2.446v-2.444zm-10.404.073h2.443v2.443H1.498v-2.443z"
});

const SvgPattern = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPattern, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pattern.be040995.svg";
export { ForwardRef as ReactComponent };